export enum EVia {
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum EMode {
  SIGNUP = 'Sign up',
  LOGIN = 'Login',
  VERIFICATION = 'Continue',
  PROFILE = 'Agree and Sign up',
}

export enum ELinkText {
  SIGNUP = 'Login here',
  LOGIN = 'Sign up',
  VERIFICATION = 'login',
  SIGN_UP_VERIFICATION = 'sign up',
  PROFILE = 'Logout',
  RESET_PASSWORD = 'Sign up',
  NEW_PASSWORD = 'login',
}

export enum ELink {
  SIGNUP = '/login',
  LOGIN = '/signup',
  VERIFICATION = '/login',
  SIGN_UP_VERIFICATION = '/signup',
  PROFILE = '/login',
  RESET_PASSWORD = '/signup',
  NEW_PASSWORD = '/login',
}

export enum EQuestion {
  SIGNUP = 'Already have an account?',
  LOGIN = "Don't have an account?",
  VERIFICATION = 'Back to',
  SIGN_UP_VERIFICATION = 'Back to',
  PROFILE = '',
  RESET_PASSWORD = "Don't have an account?",
  NEW_PASSWORD = 'Back to',
}

export type TLoginButtonGroupsProps = {
  mode: keyof typeof EMode;
  onClick: (type: EVia) => void;
};
